import * as React from 'react';
import { useRouter } from 'next/router';
import AppRoutes from '@/const/routes';
import { LayoutLogin } from '@/components/layout';
import { Spinner, Typography } from '@/components/common';
import { VerifyEmailError } from './VerifyEmailError';
import { customEvent } from '@/lib';
import { authService } from '@/api';
// import { signIn } from 'next-auth/react';
// import NextAuthProvidersEnum from '@/const/auth';

export const VerifyCodeScreen = (): JSX.Element => {
	const router = useRouter();
	const { code } = router.query;
	const [showErrorMessage, setShowErrorMessage] = React.useState(false);
	const [isLoading, setIsLoading] = React.useState<boolean>(true);

	React.useEffect(() => {
		if (code) {
			verifyCode();
		} else {
			router.push(AppRoutes.CLIENTAPP_AUTH_SIGN_IN);
		}
	}, [code]);

	const verifyCode = async (): Promise<void> => {
		try {
			if (code) {
				const res = await authService.verifyProfile(code as string);

				if (res?.statusCode === 200 || res?.statusCode === 201) {
					setIsLoading(false);
					customEvent({
						action: 'verify_account_click',
						category: 'landing',
						label: 'Verify Account',
						value: 'Verify Account',
					});
					// Wait for 5 seconds before redirecting
					setTimeout(async () => {
						await router.push(AppRoutes.CLIENTAPP_AUTH_SIGN_IN);
					}, 5000);
				} else {
					setShowErrorMessage(true);
					setIsLoading(false);
				}
			}
		} catch (error) {
			setShowErrorMessage(true);
			setIsLoading(false);
		}
	};

	return (
		<LayoutLogin
			title=""
			buttonBack
			hrefButtonBack={AppRoutes.CLIENTAPP_AUTH_SIGN_IN}
			buttonLabelBack="Return to Sign In"
			customTitle={
				isLoading ? (
					''
				) : showErrorMessage ? (
					'Verification Link Expired'
				) : (
					<span>
						Your Email Has Been <br /> Successfully Verified
					</span>
				)
			}
		>
			{isLoading ? (
				<Spinner type="loadingPage" className="my-10 mx-auto" />
			) : showErrorMessage ? (
				<VerifyEmailError />
			) : (
				<>
					<Typography type="regular-18" className="opacity-60 text-center">
						{`Thanks for confirming your email! You’re all set and ready to get started!`}
					</Typography>
					<div className="flex justify-center w-full mt-10 mb-4">
						<Spinner type="loadingPage" />
					</div>
					<Typography type="regular-18" className="opacity-60 text-center">
						Redirecting to the sign-in page in a few seconds
					</Typography>
				</>
			)}
		</LayoutLogin>
	);
};
